import {
  type ApiCoreSessionManager,
  type Client,
  type SessionV2,
} from "@decentriq/core";
import { createContext } from "react";
import { useSafeContext } from "hooks";

export interface ApiCoreStore {
  get: <T = any>(key: string) => T | undefined;
  pop: <T = any>(key: string) => T | undefined;
  popStrict: <T = any>(key: string) => T;
  push: (key: any) => string;
  reset: () => void;
}

export interface ApiCoreContextValue {
  client: Client;
  /**
   * Reuses already fetched session if available, otherwise fetches a new one
   */
  getSession: () => Promise<SessionV2>;
  /**
   * Reuses already fetched verification key if available, otherwise fetches a new one
   */
  getVerificationKey: (session?: SessionV2) => Promise<Uint8Array>;
  driverMrsignerAttestationSpecHash: string;
  reset: () => void;
  sessionManager: ApiCoreSessionManager;
  store: ApiCoreStore;
}

export const ApiCoreContext = createContext<ApiCoreContextValue | null>(null);

export const ApiCoreProvider = ApiCoreContext.Provider;

ApiCoreContext.displayName = "ApiCoreContext";

export const useApiCore = () => useSafeContext(ApiCoreContext);

export default useApiCore;
